"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuoteCurrencyFormatter = void 0;
var react_1 = require("react");
var FormatCurrency_1 = require("@CommonFrontend/Utils/FormatCurrency");
var useProjectCurrency_1 = require("./useProjectCurrency");
var currency_formatter_1 = __importDefault(require("currency-formatter"));
var useQuoteCurrencyFormatter = function () {
    var projectCurrencyCode = (0, useProjectCurrency_1.useProjectCurrency)();
    return (0, react_1.useMemo)(function () {
        var format = function (value) {
            return (0, FormatCurrency_1.formatCurrency)(value, projectCurrencyCode, currency_formatter_1.default.findCurrency(projectCurrencyCode).decimalDigits);
        };
        var parse = function (value) {
            return (0, FormatCurrency_1.parseCurrency)(value, projectCurrencyCode);
        };
        var currencySymbol = currency_formatter_1.default.findCurrency(projectCurrencyCode).symbol;
        return { format: format, parse: parse, currencySymbol: currencySymbol };
    }, [projectCurrencyCode]);
};
exports.useQuoteCurrencyFormatter = useQuoteCurrencyFormatter;
